export default function controlUniqueNameDirective(
  $q,
  controlDataService
) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const customerControlId = attributes.customerControlId || -1;
    ngModel.$asyncValidators.controlUniqueName = (modelValue) => {
      const defer = $q.defer();
      controlDataService.checkControlNameExists(
        modelValue,
        customerControlId
      ).then((data) => {
        if (data && !data.data.result) {
          defer.resolve();
        } else {
          defer.reject();
        }
      }).catch(defer.reject);
      return defer.promise;
    };
  }
}

export const name = 'controlUniqueName';

controlUniqueNameDirective.$inject = [
  '$q',
  'controlDataService'
];
